





















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import reportingAPI from "@/services/reporting";

import { NSLog } from "@/helpers/log";
import ProductIcon from "@/components/ProductIcon.vue";
import { save, load } from "@/helpers/storage";
import { Pagination } from "@/models/pagination";
import FilterDateRange from "@/components/filters/DateRange.vue";
import { Condition, Rule } from "@/components/Pivot/views/view";
import { debounce, cancel } from "typescript-debounce-decorator";
const log = NSLog("view/ManagePackages");

@Component({
  components: {
    loader,
    ProductIcon,
    FilterDateRange
  }
})
export default class ManagePackages extends Vue {
  @Prop({ required: true }) name!: string;

  created() {
    this.refreshData();
  }

  private loading = true;
  private pagination: Pagination = {
    descending: true,
    page: 1,
    rowsPerPage: load("rows-per-page", 10),
    sortBy: "updated_at",
  };

  @Watch("pagination", { deep: true }) rowsPerPageWatch() {
    save('rows-per-page', this.pagination.rowsPerPage);
    this.refreshData();
  }

  @Watch("filters", { deep: true }) watchFilters() {
    console.log("filter changed", this.filters)
    this.refreshData();
  }

  data: any[] = [];
  columns: string[] = [];
  filters: any = {};
  lastReq = "";

  apiFilters() {
    if (!Object.keys(this.filters).length) {
      return undefined;
    }

    const rules: Condition[] = [];
    // Object.keys(this.filters).forEach(((key) => {
    //   rules.push({
    //     operator: "date-range",
    //     key,
    //     value: this.filters[key]
    //   })
    // }
    if (this.filters["date-range"]) {
      const f = this.filters["date-range"];
      if (f.from && f.to) {
        rules.push({
          operator: "date-range",
          key: "inv.updated_at",
          values: [moment(f.from).unix(), moment(f.to).unix()],
        });
      } else {
        rules.push({
          operator: "date-range",
          key: "inv.updated_at",
          value: f,
        });
      }
    }
    return { condition: "and", rules };
  }

  async refreshData() {
    this.loading = true;
    this._refreshData();
  }

  @debounce(500, { leading: false })
  async _refreshData() {
    this.pagination.sortBy = '';

    const req = {
      name: this.name,
      pagination: this.pagination,
      filter: this.apiFilters(),
    };
    console.log("new req", req);

    const newReq = JSON.stringify(req);
    if (newReq == this.lastReq) {
      this.loading = false;
      return;
    }
    console.log(newReq);
    this.lastReq = newReq;

    const res = await reportingAPI.RequestReportData(req);
    this.data = res.data;
    this.columns = res.columns;
    this.loading = false;
  }

  get totalItems() {
    if (!this.pagination || !this.pagination.rowsPerPage || !this.pagination.page) return 9999999;;
    if (this.data.length < this.pagination.rowsPerPage) {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage + this.data.length;
    }
    return this.pagination.page * this.pagination.rowsPerPage + this.pagination.rowsPerPage;
  }

  downloadLoading = false;
  async download() {
    this.downloadLoading = true;
    await reportingAPI.downloadExport({
      name: this.name,
      pagination: this.pagination,
      filter: this.apiFilters(),
    });
    this.downloadLoading = false;
  }

  private get headers() {
    // if (!this.data || !this.data.length) return [];
    return this.columns.map((k: string) => ({ name: k, text: this.titleCase(k), value: k }));
  }

  private get items() {
    if (this.loading) {
      return [];
    }
    return this.data;
  }

  private valueStyle(header: any, item: any) {
    return "";//this.baseView.ValueStyle(header, item[header.value], item);
  }

  private expandItem(item: any, expand: any) {
    if (!item.expanded || item.expanded.name !== expand.name) {
      item.expanded = expand;
      return;
    }
    item.expanded = false;
  }

  private titleCase(val: string) {
    return val.replace(/_/g, " ").replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  };
}
